import third from "../myWor images/third.jpg";
import fourth from "../myWor images/fourth.jpg";
import first from "../myWor images/first.png";
import five from "../myWor images/five.jpg";
import second from "../myWor images/second.png";
import six from "../myWor images/seven.jpg";
import eight from "../myWor images/eight.jpg";

export default [five, third, fourth, second, six, eight];
